import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useParams } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import {
  getOrgById,
  getOrgByRef,
  queryArticlesByOrgRef,
} from "../models/OrgFunctions.js";
import Column from "../layout/Column.js";
import Row from "../layout/Row.js";
import Divider from "../layout/Divider.js";
import Icon1 from "../icons/Icon.js";
import Space from "../layout/Space.js";
import MemberManager from "../members/MemberManager.js";
import InfoCell from "../listviews/InfoCell.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import LineChart1 from "../charts/LineChart1.js";
import PieChart1 from "../charts/PieChart1.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import PartnersAM from "../actionmenus/PartnersAM.js";
import { Skeleton, Switch } from "@mui/material";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTimeFromSeconds,
  getOrgDataById,
  last_of_list,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import { useAppContext } from "../config/AppContext.js";
import { useTheme } from "@mui/material";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import NotesClient from "../notes/NotesClient.js";
import InfoCellField from "../listviews/InfoCellField.js";
import { useSnackbar } from "notistack";
import DropDownGPT1 from "../dropdowns/DropDownGPT1.js";

import Box from "@mui/material/Box";
import createNewMember from "../api/create/createNewMember.js";
import Tarifs from "../modals/Tarifs.js";
import Modal1 from "../modals/Modal1.js";
import sendInvite from "../api/send/sendInvite.js";
import TextField2 from "../textfields/TextField2.js";
import { set } from "date-fns";
import SmallSpinner from "../loading/SmallSpinner.js";
import MembresClient from "../members/MemberClient.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import { getRoleString } from "./parameters/Organisation.js";
import MemberModal from "../modals/MemberModal.js";
import Tippy from "@tippyjs/react";
import checkPageAccess, { checkPageAccessV2 } from "../auth/checkPageAccess.js";
import CustomAccordion from "../layout/CustomAccordion.js";
import { DatePicker, Spin } from "antd";
import DatePickerFlutter from "../textfields/DatePickerFLutter.js";
import TextField2T from "../textfields/TextField2T.js";
import DatePickerGPT0 from "../textfields/DatePickerGPT0.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import { EasySwitch, ToggleSettingsBrick } from "../textfields/EasySwitch.js";
import { firstPlan } from "../hexagone/VisibilityHelpers.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import { getAllVisibleDocumentxxs } from "../products/documentsHelpers.js";

function Partner({
  userData,
  orgData,
  navigateWorkspace,
  refreshFolders,
  workspaceData,
}) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();
  const theme = useTheme();

  const [documentxx, setDocumentxx] = useState(null);
  const [accesses, setAccesses] = useState({});
  const [email_templates, setEmailTemplates] = useState(null);
  const [foldersCount, setFoldersCount] = useState(0);

  const [tarifs_open, setTarifsOpen] = useState(false);
  const [tarif_selected, setTarifSelected] = useState(null);
  const [graphData, setGraphData] = useState(null);

  const [x_values, setXValues] = useState(null);
  const [since, setSince] = useState("week");
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const saved_data = appState.saved_data;
  const [users, setUsers] = useState([]);
  const [partners, setPartners] = useState([]);
  const [partners_items, setPartnerItems] = useState([]);
  const [partnerData, setPartnerData] = useState([]);

  const [commercial_infos, setCommercialInfos] = useState(null);
  const [add_intervenant_name_value, setAddIntervenantNameValue] = useState("");
  const [add_member_email_value, setAddMemberEmailValue] = useState("");

  const [marque, setMarque] = useState("");
  const [marques, setMarques] = useState([]);

  const echeance_items = [
    {
      value: 15,
      label: "15 jours",
    },
    {
      value: 30,
      label: "30 jours",
    },
    {
      value: 45,
      label: "45 jours",
    },
    {
      value: 60,
      label: "60 jours",
    },
  ];

  const [articles, setArticles] = useState([]);
  const [role, setRole] = useState("");
  const [display_name, setDisplayName] = useState("");

  const [membres_open, setMembresOpen] = useState(false);
  const [opened_email, setOpenedEmail] = useState(false);
  const [marqueOpen, setMarqueOpen] = useState(false);
  const [workspace, setWorkspaceData] = useState(null);
  const onOpenTarifModal = (article) => {
    setTarifsOpen(true);
    if (article) {
      setTarifSelected(article);
    }
  };

  const handleSaveLinkedMarques = async () => {
    await Promise.all(
      users.map(
        (user) =>
          user.linked_marques !== undefined &&
          updateDocDataFieldApi(
            user.ref,
            "linked_marques",
            user.linked_marques || [],
            prefix
          )
      )
    );
    handleClickVariant("Marques enregistrées", "success");
    handleFetchData();
  };
  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (currentUser) {
      try {
        // Fetch user data

        if (
          (await checkPageAccessV2(
            userData,
            orgData,
            workspaceData,
            "basic"
          )) == false
        ) {
          navigateWorkspace("/home");
        }

        // Fetch organization data using user's org reference

        let article_filters = [
          {
            field: "org_id",
            operator: "==",
            value: orgData.id,
          },
        ];

        // Fetch articles for the organization
        const articles = await queryCollection("article", article_filters);

        let my_folders = appState.saved_data.folders || [];
        my_folders = my_folders.filter(
          (folder) =>
            (folder.partners_id || []).includes(id) || folder.client_id === id
        );
        setFoldersCount(my_folders.length);
        // Fetch client data using the provided id in params
        const partner = await getOrgById(id);
        const partner_workspaces = await getArrayDocDataByID(
          "workspace",
          partner.workspaces_id
        );

        let workspace = partner_workspaces.find(
          (workspa) => workspa.master_id === orgData.id
        );
        if (!workspace) {
          console.error("Workspace not found for partner:", id);
          handleClickVariant("Workspace client non trouvé", "error");
          navigateWorkspace("/partners");
          return;
        }
        setWorkspaceData(workspace);
        if (!partner) {
          handleClickVariant("Partenaire non trouvé", "error");
          navigateWorkspace("/partners");
        }

        const documentsxx = await getAllVisibleDocumentxxs(orgData);
        let all_documentsxx = [
          {
            id: "thermal",
            name: "Documents étude thermique et xml",
          },
          {
            id: "modif_thermal",
            name: "Mise à jour étude thermique",
          },
        ];
        all_documentsxx = [...all_documentsxx, ...documentsxx];

        setDocumentxx(all_documentsxx);
        let filters_email = [
          {
            field: "org_id",
            operator: "==",
            value: orgData.id,
          },
        ];
        const email_templates = await queryCollection(
          "email_template",
          filters_email
        );

        email_templates.push({
          id: "new_message_" + orgData.id,
          name: "Message Chat",
        });

        setEmailTemplates(email_templates);
        let accesses = {};
        if (!workspace?.accesses) {
          for (let i = 0; i < all_documentsxx.length; i++) {
            accesses[all_documentsxx[i].id] = true;
          }
          await updateDocDataFieldApi(
            workspace.ref,
            "accesses",
            accesses,
            prefix
          );
          handleClickVariant("Accès initialisés", "success");
          setAccesses(accesses || {});
        } else {
          accesses = workspace.accesses || {};
          setAccesses(workspace.accesses || {});
        }
        // check if the accesses are all true
        setAllAccesses(
          Object.values(accesses || {}).every((access) => access === true) &&
            Object.values(accesses || {}).length > 0
        );

        let commercial_infos = workspace.commercial_infos || {};
        setCommercialInfos(commercial_infos);

        if (partner.marques) {
          setMarques(partner.marques.map((marque) => marque.name) || []);
        } else {
          let marques = [
            {
              name: partner.name,
              tampon_url: "",
              signature_url: "",
            },
          ];
          await updateDocDataFieldApi(partner.ref, "marques", marques, prefix);
          handleClickVariant("Marque initialisée", "success");
          setMarques([partner.name]);
        }

        let affiliated_partners_id = workspace.affiliated_partners_id || [];

        const partners = await getArrayDocDataByID(
          "org",
          affiliated_partners_id || []
        );

        setPartners(partners);
        const filters = [
          {
            field: "masters_id",
            operator: "array-contains",
            value: orgData.id,
          },
        ];
        const all_partners = await queryCollection("org", filters);
        setPartnerItems(
          all_partners
            .filter(
              (part) =>
                part.id !== partner.id && !(partners || []).includes(part.id)
            )
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((partner) => {
              return {
                value: partner.id,
                label: partner.name,
              };
            })
        );

        const users = await getArrayDocDataByID("user", partner.users_id);
        setUsers(users);

        setGraphData([]);

        setXValues([]);

        // Update state with fetched data

        setPartnerData(partner);
        setArticles(articles);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [all_accesses, setAllAccesses] = useState(false);
  const [allEmailsEnabled, setAllEmailsEnabled] = useState(false);

  const handleSetAllAccesses = async (value) => {
    setAllAccesses(value);
    let new_accesses = {};
    for (let i = 0; i < documentxx.length; i++) {
      new_accesses[documentxx[i].id] = value;
    }
    setAccesses(new_accesses);
  };

  const handleResetClientID = async () => {
    await updateDocDataFieldApi(
      partnerData.ref,
      "pennylane.client_id",
      null,
      prefix
    );
    handleClickVariant("Client ID réinitialisé", "success");
    handleFetchData();
  };

  const handleSaveAdmin = async (permissions) => {
    await updateDocDataFieldApi(
      workspace.ref,
      "permissions",
      permissions,
      prefix
    );
    handleClickVariant("Administrateur enregistré", "success");
    handleFetchData();
  };

  const handleSaveEmoji = async (emoji) => {
    if (!workspace) return;
    let new_workspace = { ...workspace, emoji: emoji };
    await updateDocDataFieldApi(new_workspace.ref, "emoji", emoji, prefix);
    setWorkspaceData(workspace);
  };

  const handleChangeListenUser = (e, user_id, email_id) => {
    let user = users.find((user) => user.id === user_id);
    if (!user) return;
    let new_listen_emails = user.listen_emails || [];

    // If the email is not already in the list, add it
    if (!new_listen_emails.includes(email_id)) {
      new_listen_emails.push(email_id);
    } else {
      // If the email is in the list, remove it
      new_listen_emails = new_listen_emails.filter(
        (email) => email !== email_id
      );
    }

    let new_users = users.map((u) => {
      if (u.id === user_id) {
        return { ...u, listen_emails: new_listen_emails };
      }
      return u;
    });
    setUsers(new_users);
  };

  function checkAccessExists() {
    // loop for each document
    for (let i = 0; i < documentxx?.length; i++) {
      // if the access does not exist
      if (accesses && accesses[documentxx[i].id]) {
        return false;
      }
    }

    return true;
  }

  const handleFetchTarifs = async () => {
    setTarifsOpen(false);
    await handleFetchData();
  };

  const handlesendInvite = async () => {
    const token = await getOrRefreshFirebaseToken(); // Fetch Firebase token
    let new_user = await getUserById(partnerData.users_id[0]);
    let org = await getOrgDataById(new_user.org_id);
    if (org.invite !== "accepted") {
      await updateDocDataFieldApi(org.ref, "invite", "sent", prefix);
    }
    await sendInvite(
      new_user.id,
      orgData.name,
      new_user.email,
      org.id,
      token,
      prefix
    ); // Call the sendInvite API
    handleClickVariant("Invitation envoyée avec succès", "success");
  };

  const handleSaveContrat = async () => {
    await updateDocDataFieldApi(
      workspace.ref,
      "commercial_infos",
      commercial_infos,
      prefix
    );
    handleClickVariant("Informations commerciales enregistrées", "success");
    handleFetchData();
  };

  const [loadingMarque, setLoadingMarque] = useState(false);

  const handleAddMarque = async (index) => {
    setLoadingMarque(true);
    if (index === true) {
      let marques = partnerData.marques || [];
      marques.push({ name: marque, tampon_url: "", signature_url: "" });
      await updateDocDataFieldApi(partnerData.ref, "marques", marques, prefix);
      handleClickVariant("Marque ajoutée", "success");
      handleFetchData();
    } else {
      let real_index = index - 1;
      let old_marque = partnerData.marques[real_index];
      let new_marque = { ...old_marque, name: marque };
      let marques = partnerData.marques || [];
      marques[real_index] = new_marque;

      await updateDocDataFieldApi(partnerData.ref, "marques", marques, prefix);
      handleClickVariant("Marque modifiée", "success");

      let filters = [
        {
          field: "client_id",
          operator: "==",
          value: partnerData.ref,
        },
        {
          field: "marque",
          operator: "==",
          value: old_marque.name,
        },
      ];
      let affected_folders = await queryCollection("folder", filters);
      await Promise.all(
        affected_folders.map((folder) =>
          updateDocDataFieldApi(folder.ref, "marque", marque, prefix)
        )
      );
      handleClickVariant("Dossier(s) modifié(s)", "success");
      // wait for 1 second

      // doing this to trigger the saved date update
      if (affected_folders.length > 0) {
        await updateDocDataFieldApi(
          affected_folders[0].ref,
          "marque",
          old_marque.name,
          prefix
        );

        refreshFolders();
        await updateDocDataFieldApi(
          affected_folders[0].ref,
          "marque",
          marque,
          prefix
        );
      }
      await handleFetchData();
    }
    setMarqueOpen(false);
    setLoadingMarque(false);
  };

  const handleRemoveMarque = async (marque) => {
    let marques = partnerData.marques || [];
    marques = marques.filter((m) => m.name !== marque);
    await updateDocDataFieldApi(partnerData.ref, "marques", marques, prefix);
    handleClickVariant("Marque retirée", "success");
    handleFetchData();
  };

  const handleSaveAccesses = async () => {
    await updateDocDataFieldApi(workspace.ref, "accesses", accesses, prefix);

    handleClickVariant("Accès enregistrés", "success");
    handleFetchData();
  };

  const handleSaveEmails = async () => {
    await Promise.all(
      users
        .filter((user) => user.listen_emails)

        .map((user) =>
          updateDocDataFieldApi(
            user.ref,
            "listen_emails",
            user.listen_emails,
            prefix
          )
        )
    );
    handleClickVariant("Préférences emails enregistrés", "success");
    handleFetchData();
  };

  const handleToggleAllEmails = (value) => {
    setAllEmailsEnabled(value);
    let new_users = users.map((user) => {
      if (value) {
        // Enable all emails: add all email_template ids to listen_emails
        let all_email_ids = email_templates?.map((email) => email.id) || [];
        return { ...user, listen_emails: all_email_ids };
      } else {
        // Disable all emails: clear listen_emails
        return { ...user, listen_emails: [] };
      }
    });
    setUsers(new_users);
  };

  const handleAddPartner = async (id) => {
    const partner = await getOrgById(id);
    let affiliated_partners_id = workspace.affiliated_partners_id || [];

    affiliated_partners_id.push(partner.id);
    await updateDocDataFieldApi(
      workspace.ref,
      "affiliated_partners_id",
      affiliated_partners_id,
      prefix
    );
    handleClickVariant("Partenaire ajouté", "success");
    handleFetchData();
  };

  function getNegocePriceWorkspace(article) {
    if (!workspace) return { price_ht_rounded: 0, price_ttc_rounded: 0 };
    const negoces = workspace?.negoces || [];

    const negoce = negoces.find((neg) => neg.article_id === article?.id);

    const price_ht = negoce ? parseFloat(negoce.price_ht) : 0;
    const price_ttc = negoce ? parseFloat(negoce.price_ht) * 1.2 : 0;

    // Round it to 2 decimal places
    const price_ht_rounded = price_ht?.toFixed(2);
    const price_ttc_rounded = price_ttc?.toFixed(2);

    return {
      price_ht_rounded: isNaN(price_ht_rounded)
        ? "-"
        : price_ht_rounded == 0
          ? "-"
          : price_ht_rounded,
      price_ttc_rounded: isNaN(price_ttc_rounded)
        ? "-"
        : price_ttc_rounded == 0
          ? "-"
          : price_ttc_rounded,
    };
  }

  const handleImpersonate = async () => {
    if (partnerData.email === "william.bresso@gmail.com") {
      handleClickVariant(
        "Impersonation désactivée pour cette organisation",
        "error"
      );
      return;
    }
    let client_user_id = partnerData.users_id[0];
    let workspaces_id = partnerData.workspaces_id || [];
    let workspaces = await getArrayDocDataByID("workspace", workspaces_id);
    let my_workspace = workspaces.find(
      (workspace) => workspace.master_id === orgData.id
    );
    navigateWorkspace(
      "/imp/" + client_user_id + "/workspace/" + my_workspace.id + "/home",
      partnerData,
      my_workspace.id
    );
  };

  function formatAsCurrency(value) {
    // Ensure the value is a number with two decimal places
    // make sure it can be isFIxed
    if (value === "-") {
      return "-";
    }
    if (!value && value !== 0) {
      return "0,00€";
    }
    if (typeof value === "number") {
      value = value.toFixed(2);
    }

    // Replace period with comma
    const formattedValue = value.replace(".", ",");
    return `${formattedValue}€`;
  }

  const handleRemovePartner = async (id) => {
    let affiliated_partners_id = workspace.affiliated_partners_id || [];

    affiliated_partners_id = affiliated_partners_id.filter(
      (partner_id) => partner_id !== id
    );
    await updateDocDataFieldApi(
      workspace.ref,
      "affiliated_partners_id",
      affiliated_partners_id,
      prefix
    );
    handleClickVariant("Intervenant affilié retiré", "success");
    handleFetchData();
  };
  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  useEffect(() => {
    // Calculate if all emails are enabled
    if (users.length > 0 && email_templates && email_templates.length > 0) {
      const allEnabled = users.every((user) => {
        const userEmailIds = user.listen_emails || [];
        const allEmailIds = email_templates.map((email) => email.id);
        return allEmailIds.every((emailId) => userEmailIds.includes(emailId));
      });
      setAllEmailsEnabled(allEnabled);
    } else {
      setAllEmailsEnabled(false);
    }
  }, [users, email_templates]);

  const [memberOpen, setMemberOpen] = useState(false);

  // Handle navigation to clients page
  const gotoPartners = () => {
    navigateWorkspace("/partners");
  };

  const gomodifyClient = () => {
    navigateWorkspace("/modifypartner/" + id);
  };
  // loading || !currentUser || !userData

  if (loading || !currentUser || !userData || !partnerData) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row gap-2 mt-3">
        <SmallSpinner />
      </div>
    );
  }

  return (
    <div className="flex-row w-full h-full overflow-auto gap-10 flex ">
      <Modal1 isOpen={tarifs_open} onClose={() => setTarifsOpen(false)}>
        <Tarifs
          onClose={handleFetchTarifs}
          extra={{
            params: tarif_selected,
            id: id,
            negoce: getNegocePriceWorkspace(tarif_selected),
          }}
          workspace={workspace}
        ></Tarifs>
      </Modal1>
      <Modal1 isOpen={memberOpen} onClose={() => setMemberOpen(null)}>
        <MemberModal
          onClose={() => setMemberOpen(null)}
          user_id={memberOpen}
          onUpdate={handleFetchData}
          orgData={partnerData}
        />
      </Modal1>
      <Modal1 isOpen={marqueOpen} onClose={() => setMarqueOpen(false)}>
        <div className="flex flex-col p-4 rounded-xl bg-white shadow-md w-fit ">
          {loadingMarque && (
            <div className="flex flex-row text-h3 text-shadow_50 gap-2 items-center  justify-center w-full h-full">
              <SmallSpinner loading={true}></SmallSpinner> Modification des
              dossiers en cours
            </div>
          )}
          {!loadingMarque && (
            <div className="flex flex-col gap-2 max-w-c500  w-c400 ">
              <TextField2T
                label="Nom de marque"
                className="w-c400"
                value={marque}
                onChange={(e) => setMarque(e.target.value)}
                transparent={false}
              ></TextField2T>
              {marqueOpen !== true && (
                <div className="text-h3 font-light text-gray-400">
                  En modifiant le nom de la marque, vous modifiez le nom de la
                  marque pour tous les dossiers affiliés à cette marque.
                </div>
              )}
              <div className="flex flex-row justify-between">
                <SecondaryButton
                  onClick={() => {
                    setMarqueOpen(false);
                    setMarque("");
                  }}
                >
                  Annuler
                </SecondaryButton>
                <PrimaryButton
                  className="w-fit"
                  disabled={marque === ""}
                  onClick={() => handleAddMarque(marqueOpen)}
                >
                  {marqueOpen !== true
                    ? "  Appliquer à tous les dossiers affiliés"
                    : "Enregistrer"}
                </PrimaryButton>
              </div>
            </div>
          )}
        </div>
      </Modal1>

      {/* Left Column: Takes all available space */}
      <div className="flex flex-col h-fit flex-grow pl-4 gap-1  max-w-c1k">
        <Space y={20} />
        <div className="w-full flex flex-row ">
          <div
            className="w-fit cursor-pointer flex flex-row items-center"
            onClick={gotoPartners}
          >
            <div className="text-h2 font-semibold text-primary_l bg-transparent">
              Partenaires
            </div>
            <Icon1 icon_name="right" height="15px"></Icon1>
          </div>

          <div className="flex flex-row justify-end gap-2 w-full ">
            <SecondaryButton
              className="min-w-fit"
              onClick={handleImpersonate}
              disabled={false}
            >
              Accéder à la vue du partenaire
            </SecondaryButton>
            <SecondaryButton className="min-w-fit" onClick={handlesendInvite}>
              Envoyer invitation
            </SecondaryButton>
            <PartnersAM
              userData={userData}
              masterData={orgData}
              actionModify={gomodifyClient}
              clientData={partnerData}
              navigateWorkspace={navigateWorkspace}
            />
          </div>
        </div>
        <Space y={5} />
        <div className="flex flex-row gap-2 items-center">
          <PartnerEmoji workspace={workspace} saveEmoji={handleSaveEmoji} />
          <div className="text-hx font-semibold">{partnerData?.name}</div>
        </div>
        <div
          className={`inline-flex w-fit items-center mt-2 rounded-full text-h3 px-2 py-0.5 flex-row ${partnerData.partner_type === "constructor" ? "text-indigo-500 bg-indigo-50" : "text-blue-400  bg-blue-50 "}  font-light `}
        >
          {getPartnerTypeName(partnerData?.partner_type)}
        </div>
        <div
          className={`inline-flex w-fit items-center mt-2 rounded-full text-h3 px-2 py-0.5 flex-row ${!workspace?.permissions?.payment_allowed ? "text-indigo-500 bg-indigo-50" : "text-blue-400  bg-blue-50 "}  font-light `}
        >
          {workspace?.permissions?.payment_allowed
            ? "Paiement hexagone"
            : "Paiement externe"}
        </div>
        {checkAccessExists() && (
          <div className="flex flex-col  w-fit rounded-xl items-center h-fit my-1 bg-red-50 p-2 border-l-3 border-red-400 ">
            <div className="text-h2 text-red-400 font-medium   gap-2 flex flex-row items-center">
              <Icon1 icon_name="warning" fill="red" size={25} />
              Vous n'avez pas encore défini d'accès par défaut pour les
              documents
            </div>
          </div>
        )}
        <Space y={15} />
        <CustomAccordion userData={userData} title="Membres" disabled={false}>
          <MembresClient
            title=""
            users={users}
            orgData={partnerData}
            masterData={orgData}
            prefix={prefix}
            handleRefresh={handleFetchData}
            setMemberOpen={setMemberOpen}
            disabled={
              partnerData?.facturation?.plan !== "free" ||
              partnerData?.workspaces_id?.length > 1
            }
          ></MembresClient>
        </CustomAccordion>
        <CustomAccordion userData={userData} title="Partenaires affiliés">
          <div className="w-full pl-2 mt-2">
            <div className="text-h2 font-medium ">
              Partenaires qui seront automatiquement ajoutés aux nouveaux
              dossiers de cette entreprise
            </div>

            <div className="flex flex-row gap-2 max-w-c500 mt-4">
              <DropDownGPT1
                label="Entreprise"
                items={partners_items}
                className="w-c500"
                value={add_intervenant_name_value}
                onChange={(e) => handleAddPartner(e.value)}
              ></DropDownGPT1>
            </div>

            <Space y={10} />
            <div className="w-c500">
              <Box
                sx={{
                  width: "100%",
                  borderRadius: "8px",
                  borderColor:
                    partners.length > 0
                      ? "rgba(0, 0, 0, 0.12)"
                      : "rgba(0, 0, 0, 0)",
                  borderWidth: "1.5px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0)",
                  overflow: "hidden",
                }}
              >
                {/* Map through users and render ListCell for each */}
                {partners.map((partner, index) => (
                  <div key={index}>
                    <div className="flex items-center justify-between w-full p-2 border-b border-gray-200">
                      {/* User Avatar and Email */}
                      <div className="flex items-center gap-2">
                        <div className="flex flex-row gap-2">
                          <img
                            src={
                              partner.logo ||
                              "https://i.ibb.co/xqZTQvtX/image.png"
                            }
                            alt="photo"
                            className="h-10 w-10 rounded-full"
                          />{" "}
                          <div className="flex flex-col">
                            <div className="text-h3">{partner.name}</div>{" "}
                            <div className="text-h5 text-nowrap text-clip max-w-full overflow-hidden text-shadow_50">
                              {partner.email}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Close Icon (Removable functionality) */}
                      <div
                        className="flex justify-end items-center cursor-pointer"
                        onClick={() => handleRemovePartner(partner.id)}
                      >
                        <Icon1
                          icon_name="delete"
                          size={16}
                          fill="grey"
                          hover_color={"red"}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </Box>
              {partners.length === 0 && (
                <>
                  <div className="flex flex-row gap-3 bg-neutral-200 rounded-xl px-2 py-1 w-fit">
                    <div className="text-h3 font-semibold text-shadow_50">
                      Aucun partenaire affilié
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </CustomAccordion>
        <CustomAccordion userData={userData} title="Marques">
          <div className="w-full pl-2 mt-2 flex flex-col ">
            <div className="text-h2 font-medium flex-row flex gap-4">
              Marques du partenaire
            </div>

            <div className="text-h3 text-shadow_50 w-c500 mb-3 mt-2 ">
              Vous pouvez ajouter des marques pour distinguer les dossiers de
              votre client (marques régionales par exemple). Chaque marque peut
              être associée à des membres spécifiques pour que seulement ces
              utilisateurs recoivent les notifications de l'envoi de message
              dans le chat des dossiers de cette marque.
            </div>

            <SecondaryButton
              onClick={() => {
                setMarque("");
                setMarqueOpen(true);
              }}
              className={"w-fit"}
            >
              Ajouter une marque
            </SecondaryButton>
            <div className="w-full border-1 border-shadow_10 mt-4 rounded-md min-h-fit">
              {/* Map through users and render ListCell for each */}
              {marques.map((marque, index) => (
                <div
                  key={index}
                  className="flex flex-col  p-1  border-b border-gray-200"
                >
                  <div className="flex  items-center justify-between w-full gap-2">
                    {/* User Avatar and Email */}
                    <div className="flex flex-row items-center gap-2 w-full">
                      <Icon1 icon_name="flag" fill="grey" size={20}></Icon1>
                      <div className="text-sm">{marque}</div>
                      <div className="text-sm  bg-blue-50 ml-auto text-blue-400 rounded-full px-2 py-0.5 font-light">
                        {
                          saved_data?.folders?.filter(
                            (f) => f.marque === marque
                          ).length
                        }{" "}
                        dossiers
                      </div>
                    </div>

                    {/* Close Icon (Removable functionality) */}
                    <SecondaryButton
                      onClick={() => {
                        setMarque(marque);
                        setMarqueOpen(index + 1);
                      }}
                    >
                      Modifier
                    </SecondaryButton>
                    <SecondaryButton
                      disabled={
                        saved_data?.folders?.filter((f) => f.marque === marque)
                          .length > 0
                      }
                      onClick={() => handleRemoveMarque(marque)}
                    >
                      Supprimer
                    </SecondaryButton>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {users
                      .sort((a, b) =>
                        a.display_name.localeCompare(b.display_name)
                      )
                      .map((user, user_index) => (
                        <div
                          key={user_index}
                          className="bg-white rounded-lg flex flex-row text-shadow_50 items-center gap-1 px-1 text-h4"
                        >
                          <CheckBoxGrey
                            checked={
                              user.linked_marques === undefined
                                ? true
                                : user.linked_marques?.includes(marque)
                            }
                            onChange={(checked) => {
                              let new_users = users
                                .sort((a, b) =>
                                  a.display_name.localeCompare(b.display_name)
                                )
                                .map((u) => {
                                  if (u.id === user.id) {
                                    let linked_marques = u.linked_marques || [];
                                    if (checked) {
                                      linked_marques.push(marque);
                                    } else {
                                      linked_marques = linked_marques.filter(
                                        (m) => m !== marque
                                      );
                                    }
                                    return { ...u, linked_marques };
                                  }
                                  return u;
                                });
                              //setUsers(new_users);
                            }}
                          ></CheckBoxGrey>

                          {user.display_name || user.email}
                        </div>
                      ))}
                  </div>
                </div>
              ))}

              {marques.length === 0 && (
                <>
                  <div className="flex flex-row gap-3 bg-neutral-200 rounded-xl px-2 py-1 w-fit">
                    <div className="text-h3 font-semibold text-shadow_50">
                      Aucune marque enregistrée
                    </div>
                  </div>
                </>
              )}
            </div>
            <PrimaryButton
              className="w-fit mt-4"
              onClick={() => {
                handleSaveLinkedMarques();
              }}
            >
              Enregistrer
            </PrimaryButton>
          </div>
        </CustomAccordion>
        <CustomAccordion userData={userData} title="Informations commerciales">
          <div className="flex flex-col w-full pl-2 mt-2">
            <div className="text-h2 font-medium">Informations de contact</div>
            <Space y={20} />
            <div className=" w-full flex xl:flex-row flex-col  gap-6 xl:gap-2  pr-2">
              <div className="flex flex-col w-2/3 gap-6 xl:gap-2 pr-2">
                <div className=" w-full flex xl:flex-row flex-col  gap-6 xl:gap-2 ">
                  <div className="flex flex-col gap-2 w-full  pr-2">
                    <div className="text-h2 font-medium">Responsable</div>
                    <Space y={5} />
                    <TextField2T
                      label="Nom"
                      value={commercial_infos?.nom_respo || ""}
                      onChange={(e) =>
                        setCommercialInfos({
                          ...commercial_infos,
                          nom_respo: e.target.value,
                        })
                      }
                    />
                    <TextField2T
                      label="Email"
                      value={commercial_infos?.email_respo || ""}
                      onChange={(e) =>
                        setCommercialInfos({
                          ...commercial_infos,
                          email_respo: e.target.value,
                        })
                      }
                      type="email"
                    />
                    <TextField2T
                      label="Téléphone"
                      value={commercial_infos?.phone_respo || ""}
                      onChange={(e) =>
                        setCommercialInfos({
                          ...commercial_infos,
                          phone_respo: e.target.value,
                        })
                      }
                      type="phone"
                    />
                  </div>

                  <div className="flex-col flex gap-2 w-full ">
                    <div className="text-h2 font-medium">
                      Service comptabilité
                    </div>
                    <Space y={5} />
                    <TextField2T
                      label="Nom"
                      value={commercial_infos?.nom_compta || ""}
                      onChange={(e) =>
                        setCommercialInfos({
                          ...commercial_infos,
                          nom_compta: e.target.value,
                        })
                      }
                    />
                    <TextField2T
                      label="Email"
                      type="email"
                      value={commercial_infos?.email_compta || ""}
                      onChange={(e) =>
                        setCommercialInfos({
                          ...commercial_infos,
                          email_compta: e.target.value,
                        })
                      }
                    />
                    <TextField2T
                      label="Téléphone"
                      value={commercial_infos?.phone_compta || ""}
                      onChange={(e) =>
                        setCommercialInfos({
                          ...commercial_infos,
                          phone_compta: e.target.value,
                        })
                      }
                      type="phone"
                    />
                  </div>
                </div>
                <MLTFGPT1
                  value={commercial_infos?.notes || ""}
                  onChange={(e) =>
                    setCommercialInfos({
                      ...commercial_infos,
                      notes: e.target.value,
                    })
                  }
                  label={"Notes commerciales"}
                  rows={4}
                ></MLTFGPT1>
              </div>

              <div className="flex-col flex gap-2 w-1/3 pr-2">
                {" "}
                <div className="text-h2 font-medium">Partie Commerciale</div>
                <Space y={5} />
                <DatePickerGPT0
                  label="Date de début de contrat"
                  seconds={commercial_infos?.start_deal_date?.seconds}
                  onChange={(e) => {
                    if (e) {
                      let seconds = e;
                      let date = getFlutterTimeFromSeconds(seconds);

                      setCommercialInfos({
                        ...commercial_infos,
                        start_deal_date: date,
                      });
                    }
                  }}
                />
                <DatePickerGPT0
                  label="Date de dernière visite"
                  seconds={commercial_infos?.last_visit_date?.seconds || ""}
                  onChange={(e) => {
                    if (e) {
                      let seconds = e;
                      let date = getFlutterTimeFromSeconds(seconds);

                      setCommercialInfos({
                        ...commercial_infos,
                        last_visit_date: date,
                      });
                    }
                  }}
                />
                <DropDownGPT03
                  label="Echéance de paiement"
                  items={echeance_items}
                  value={commercial_infos?.echeance_paiement || ""}
                  onChange={(e) =>
                    setCommercialInfos({
                      ...commercial_infos,
                      echeance_paiement: e.value,
                    })
                  }
                />
                <TextField2T
                  label="Commercial qui s'occupe du client"
                  value={commercial_infos?.commercial_client || ""}
                  onChange={(e) =>
                    setCommercialInfos({
                      ...commercial_infos,
                      commercial_client: e.target.value,
                    })
                  }
                />{" "}
                <TextField2T
                  label="Référence de contrat"
                  value={commercial_infos?.contract_reference || ""}
                  onChange={(e) =>
                    setCommercialInfos({
                      ...commercial_infos,
                      contract_reference: e.target.value,
                    })
                  }
                />
                <div className="mt-4 flex flex-row justify-end">
                  {" "}
                  <PrimaryButton
                    className="w-fit"
                    disabled={commercial_infos === partnerData.commercial_infos}
                    onClick={handleSaveContrat}
                  >
                    Enregistrer
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </CustomAccordion>
        <CustomAccordion userData={userData} title="Tarifs négociés">
          <div className="flex flex-col gap-2 mt-2 pl-2 ">
            <div className="text-h2 font-medium">
              Tarifs des articles négociés
            </div>
            <div className="text-h3 font-regular text-shadow_50 w-c500">
              Par défaut le tarif de chaque article est égal au prix de base que
              vous avez fixé pour cet article. Vous pouvez définir un nouveau
              tarif spécifique au partenaire dans le cas où vous avez négocié un
              prix.
            </div>
            <div className="w-full flex mt-2">
              <div className="flex flex-col border-1 border-shadow_10  rounded-xl w-full h-fit ">
                {/* Table Header */}
                <div className=" items-center flex flex-row gap-2 border-b border-gray-200  p-2">
                  <div className="text-h3 font-semibold text-black  w-c400">
                    Article
                  </div>
                  <div className="text-h3 font-semibold text-shadow_50  w-c150">
                    Prix de base
                  </div>
                  <div className="text-h3 font-semibold text-black   w-c150">
                    Prix négocié HT
                  </div>
                  <div className="text-h3 font-semibold text-shadow_50   w-c150 ">
                    Prix négocié TTC
                  </div>
                  <div className="text-h3 font-semibold text-end text-black   w-c150">
                    Action
                  </div>
                </div>

                {articles.length === 0 && (
                  <div className="flex flex-col w-full h-full items-center justify-center">
                    <div className="text-h2 font-semibold text-shadow_50">
                      Aucun article trouvé
                    </div>
                  </div>
                )}

                {articles
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((article, index) => (
                    <div
                      key={index}
                      className={`flex w-full flex-row ${
                        (
                          article.visibility
                            ? article.visibility[partnerData.id] === true
                            : false
                        )
                          ? "text-shadow_50"
                          : "text-shadow_25"
                      } gap-2 px-2  hover:bg-neutral-50 items-center ${index !== 0 ? "border-t-1 border-shadow_10 " : ""}`}
                    >
                      <div className="flex flex-row gap-2 w-full items-center">
                        <div className="text-h3 font-semibold  w-c400">
                          {article.name}
                        </div>
                        <div className="text-h3  text-shadow_50 w-c150">
                          {formatAsCurrency(article.base_price)}
                        </div>
                        <div className="text-h3 font-regular text-black w-c150">
                          {formatAsCurrency(
                            getNegocePriceWorkspace(article).price_ht_rounded
                          )}
                        </div>
                        <div className="text-h3 font-regular  w-c150">
                          {formatAsCurrency(
                            getNegocePriceWorkspace(article).price_ttc_rounded
                          )}
                        </div>
                        <div className="flex-grow flex justify-end w-c150 ">
                          <SecondaryButton
                            className="w-fit h-fit"
                            onClick={() => onOpenTarifModal(article)}
                          >
                            Modifier
                          </SecondaryButton>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>{" "}
          </div>
        </CustomAccordion>
        <CustomAccordion userData={userData} title="Accès">
          <div className="flex flex-col gap-2 pl-2 mt-2">
            <div className="text-h2 font-medium ">
              Accès documents dossiers par défaut
            </div>
            <div className="text-h3 font-regular text-shadow_50 ">
              Vous pouvez définir un accès par défaut aux documents des nouveaux
              dossiers créés pour ce partenaire. Changer l'accès pour un dossier
              spécifique est possible dans la page de détail du dossier.
            </div>{" "}
            <div className="text-h3 font-regular text-shadow_50 ">
              Les changements sur les accès par défaut ne s'appliqueront pas aux
              dossiers déjà créés.
            </div>
            <div className="w-full flex mt-2">
              <div className="flex flex-col border-1 border-shadow_10  rounded-xl w-full h-fit ">
                {/* Table Header */}
                <div
                  className={`flex w-full flex-row gap-2 px-2 py-1 hover:bg-neutral-50 items-centerborder-t-1 border-shadow_5 `}
                >
                  <div className="flex flex-row gap-2 w-full">
                    <div className="text-h3 font-semibold text-shadow_50 w-c400">
                      Tous les documents
                    </div>

                    <div className="flex-grow flex justify-end ">
                      <EasySwitch
                        checked={all_accesses}
                        onChange={handleSetAllAccesses}
                      ></EasySwitch>
                    </div>
                  </div>
                </div>
                {documentxx
                  ?.sort((a, b) => a.name.localeCompare(b.name))
                  .map((doc, index) => (
                    <div
                      key={index}
                      className={`flex w-full flex-row gap-2 px-2 py-1 hover:bg-neutral-50 items-center ${index !== 0 ? "border-t-1 border-shadow_5 " : ""}`}
                    >
                      <div className="flex flex-row gap-2 w-full">
                        <div className="text-h3 font-semibold text-shadow_50 w-c400">
                          {doc.name}
                        </div>

                        <div className="flex-grow flex justify-end ">
                          <EasySwitch
                            checked={accesses[doc.id]}
                            onChange={() => {
                              setAccesses((prevAccesses) => ({
                                ...prevAccesses,
                                [doc.id]: !prevAccesses[doc.id], // Toggle the value
                              }));
                            }}
                          ></EasySwitch>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>{" "}
            <Space y={5} />
            <div className="flex flex-row justify-end w-full gap-2 ">
              <PrimaryButton
                className="w-fit"
                disabled={accesses === workspace?.accesses}
                onClick={handleSaveAccesses}
              >
                Enregistrer
              </PrimaryButton>
            </div>{" "}
          </div>
        </CustomAccordion>
        <CustomAccordion userData={userData} title="Notifications emails">
          <div className="flex flex-col gap-2 pl-2 ">
            <div className="text-h2 mt-2 font-medium">
              Réception des emails de notification par les membres du partenaire
            </div>
            <div className="text-h3 font-regular text-shadow_50 ">
              Vous pouvez activer ou désactiver la réception des emails de
              notification pour les membres du partenaire.
            </div>{" "}
            <div className="text-h3 font-regular text-shadow_50 ">
              Les changements sur les emails de notification s'appliquent
              immédiatement sur tous les emails envoyés à partir du changement.
            </div>
            <div className="w-full flex mt-4 mb-2">
              <div className="flex flex-row items-center justify-between w-full p-3 border-1 border-blue-200 bg-blue-50 rounded-xl">
                <div className="flex flex-col">
                  <div className="text-h2 font-semibold text-blue-900">
                    Activer tous les emails
                  </div>
                  <div className="text-h3 text-blue-700">
                    Active toutes les catégories d'emails pour tous les membres
                  </div>
                </div>
                <EasySwitch
                  checked={allEmailsEnabled}
                  onChange={handleToggleAllEmails}
                ></EasySwitch>
              </div>
            </div>
            <div className="w-full flex mt-2 ">
              <div className="flex flex-col border-1 border-shadow_10  rounded-xl w-full h-fit ">
                {/* Table Header */}
                {email_templates?.map((email, index) => (
                  <div
                    key={index}
                    className={`flex w-full flex-col   hover:bg-neutral-50 items-center ${index !== 0 ? "border-t-1 border-shadow_10 " : ""}`}
                  >
                    <div className="flex flex-col  w-full ">
                      <div
                        className="flex flex-row justify-between gap-2 w-full hover:bg-blue-50 cursor-pointer px-2 py-1 "
                        onClick={() =>
                          opened_email === email.id
                            ? setOpenedEmail(null)
                            : setOpenedEmail(email.id)
                        }
                      >
                        <div className="text-h3 font-semibold text-shadow_50 ">
                          {email.name}
                        </div>
                        <div
                          className={`text-h3 font-semibold text-shadow_50 ${opened_email === email.id ? "rotate-180" : ""}`}
                        >
                          <Icon1 icon_name="down" fill="grey" size={18}></Icon1>
                        </div>
                      </div>
                    </div>

                    {opened_email === email.id && (
                      <div className="flex flex-col w-full p-2 gap-1">
                        {users.map((user, index) => (
                          <div
                            key={index}
                            className="flex flex-row  justify-between   "
                          >
                            <div className=" flex-row flex w-4/5 gap-2 items-center  ">
                              <div className=" flex-row flex  w-c200 ">
                                <div
                                  className={`rounded-xl ${user.role === "operator" ? "bg-orange-100" : user.role === "respo" ? "bg-green-100" : user.role === "conductor" ? "bg-red-100" : user.role === "secretary" ? "bg-blue-100" : "bg-transparent"} w-fit  px-2 py-0.5 text-h3 text-shadow_50`}
                                >
                                  {getRoleString(user.role)}
                                </div>
                              </div>
                              <div className="text-h3 font-semibold text-shadow_50 w-c200 ">
                                {user.display_name}
                              </div>
                              <div className="text-h3 font-semibold text-shadow_50 ">
                                {user.email}
                              </div>
                            </div>
                            <EasySwitch
                              checked={
                                user.listen_emails
                                  ? user.listen_emails.includes(email.id)
                                  : false
                              }
                              onChange={(e) =>
                                handleChangeListenUser(e, user.id, email.id)
                              }
                            ></EasySwitch>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>{" "}
            <Space y={10} />
            <div className="flex flex-row justify-end w-full gap-2 ">
              <PrimaryButton className="w-fit" onClick={handleSaveEmails}>
                Enregistrer
              </PrimaryButton>
            </div>{" "}
          </div>
        </CustomAccordion>
        <CustomAccordion
          userData={userData}
          title="Configuration du partenaire"
        >
          <div className="flex flex-col gap-2 pl-2 max-w-c600 ">
            <div className="text-h2 mt-6 font-medium">
              Paramètres du partenaire
            </div>
            <div className="text-h3 font-regular text-shadow_50 ">
              Vous pouvez paramètrer le fonctionnement du débloquage des
              rapports
            </div>{" "}
            <ToggleSettingsBrick
              title="Utiliser les paiements particulier"
              description={
                "Vous pourrez ajouter des paiements particuliers sur les dossiers de ce client et les rapports lui seront automatiquement transmis au paiement du particulier"
              }
              checked={workspace?.permissions?.payment_allowed}
              onChange={(checked) => {
                handleSaveAdmin({
                  ...workspace?.permissions,
                  payment_allowed: checked,
                });
              }}
            ></ToggleSettingsBrick>{" "}
            <div className="text-h2 mt-6 font-medium">Droits du partenaire</div>
            <div className="text-h3 font-regular text-shadow_50 ">
              Vous pouvez accorder des droits à ce partenaire pour qu'il puisse
              avoir la possibilité de réaliser certaines actions.
            </div>{" "}
            <ToggleSettingsBrick
              title="Création de devis professionels (pour les clients)"
              description={
                "Ce partenaire pourra créer des devis depuis votre espace et il sera automatiquement le client de ses devis."
              }
              checked={workspace?.permissions?.new_estimates}
              onChange={(checked) => {
                handleSaveAdmin({
                  ...workspace?.permissions,
                  new_estimates: checked,
                });
              }}
            ></ToggleSettingsBrick>{" "}
            <ToggleSettingsBrick
              title="Création de dossiers professionels (pour les clients)"
              description={
                "Ce partenaire pourra créer des dossiers depuis votre espace et il sera automatiquement le client de ses dossiers."
              }
              checked={workspace?.permissions?.new_folders}
              onChange={(checked) => {
                handleSaveAdmin({
                  ...workspace?.permissions,
                  new_folders: checked,
                });
              }}
            ></ToggleSettingsBrick>{" "}
            <ToggleSettingsBrick
              title="Création de dossiers particuliers (pour les bureaux d'étude)"
              description={
                "Ce partenaire pourra créer des dossiers particulier depuis votre espace. Cette fonctionnalité est surtout utile pour les bureaux d'étude. Dans ce cas, le partenaire sera automatiquement ajouté en tant que partenaire sur les dossiers particuliers qu'il créé."
              }
              checked={workspace?.permissions?.new_particulier_folders}
              onChange={(checked) => {
                handleSaveAdmin({
                  ...workspace?.permissions,
                  new_particulier_folders: checked,
                });
              }}
            ></ToggleSettingsBrick>
            <ToggleSettingsBrick
              title="Sous traitance sur ses dossiers"
              description={
                "Ce partenaire pourra effectuer les actions en tant qu'administrateur sur les dossiers dans lesquels il est invité."
              }
              checked={workspace?.permissions?.admin_folders}
              onChange={(checked) => {
                handleSaveAdmin({
                  ...workspace?.permissions,
                  admin_folders: checked,
                });
              }}
            ></ToggleSettingsBrick>{" "}
          </div>
        </CustomAccordion>
        <Space y={100} />
      </div>

      {/* Right Column: Fixed width */}
      <div align="left" className="flex flex-col h-full min-w-c400 pl-2">
        <Space y={20} />
        <div className="text-h1 font-semibold">Informations</div>
        <Space y={5} />
        <Column align="left" className="w-full pr-2">
          <InfoCell
            title="Création"
            data={new Date(
              partnerData?.creation_date?.seconds * 1000
            ).toLocaleString()}
          />
          <InfoCell title="Entreprise" data={partnerData?.name} />{" "}
          <InfoCell title="Dossiers" data={foldersCount} />
          <InfoCell title="SIREN" data={partnerData?.infos?.siren} />
          <InfoCell
            title="Type"
            data={getPartnerTypeName(partnerData?.partner_type)}
          />
          <InfoCell title="Email" data={partnerData?.email} />
          <InfoCell title="Téléphone" data={partnerData?.phone} />
          <InfoCell title="Ville" data={partnerData?.infos?.ville} />
          <InfoCell title="Postal" data={partnerData?.infos?.postal} />
          <InfoCell title="Adresse" data={partnerData?.infos?.adresse} />
        </Column>
        {/* Notes section */}
        <Space y={25} />
        <>
          <Space y={25} />
          <div className="text-h1 font-semibold">Notes</div>
          <Space y={5} />
          <div className="pr-3 w-full max-w-c400">
            <NotesClient
              userData={userData}
              orgData={orgData}
              clientData={partnerData}
              onUpdate={handleFetchData}
              workspaceData={workspace}
            ></NotesClient>
          </div>
        </>{" "}
        <Space y={25} />
        <>
          <div className="text-h1 font-semibold">Pennylane</div>
          <Space y={5} />
          <div className="pr-3 w-full max-w-c400 gap-2 flex flex-col">
            <TextField2
              value={partnerData?.pennylane?.client_id}
              label="Client ID"
              disabled={true}
            ></TextField2>
            <SecondaryButton onClick={handleResetClientID} className={"w-fit"}>
              Réinitialiser le pennylane_client_id
            </SecondaryButton>
          </div>
        </>{" "}
        <>
          <div className="text-h1 font-semibold mt-4">Espace</div>
          <Space y={5} />
          <div className="pr-3 w-full max-w-c400 gap-2 flex flex-col">
            <TextField2
              value={workspace?.id}
              label="Espace ID"
              disabled={true}
            ></TextField2>
          </div>
        </>
      </div>
    </div>
  );
}

export default Partner;

export function getPartnerTypeName(type) {
  switch (type) {
    case "constructor":
      return "Constructeur";
    case "prospect":
      return "Prospect";
    case "mdo":
      return "Maître d'oeuvre";
    case "architect":
      return "Architecte";
    case "artisan":
      return "Artisan";
    case "drawer":
      return "Dessinateur";
    case "expert":
      return "Bureau d'étude";
    case "promotor":
      return "Promoteur";
    case "particulier":
      return "Particulier";
    case "infiltro":
      return "Infiltromètre";
    case "travaux":
      return "Entreprise de travaux";
    case "agence_immobilier":
      return "Agence immobilière";
    case "mar":
      return "MAR";
    case "other":
      return "Autre";
    default:
      return "Client inconnu";
  }
}

export const PartnerEmoji = ({ workspace, saveEmoji }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedEmoji, setSelectedEmoji] = useState(workspace?.emoji || "");

  useEffect(() => {
    if (workspace?.emoji) {
      setSelectedEmoji(workspace.emoji);
    }
  }, [workspace?.emoji]);

  const available_emojis = [
    "",
    "🤝",
    "🏗️",
    "🏠",
    "🏢",
    "🏘️",
    // emotions
    "🔥",
    "😡",
    "😢",
    "😄",
    "😐",
    "😮",
    "😎",
    "😇",
    "😈",
    "😋",
    "😜",
    "😏",
    // hearts
    "❤️",
    "💙",
    "💚",
    "💛",
    "💜",
    // symbols
    "⭐",
    "✔️",
    "❌",
    "⚠️",
    "ℹ️",
    // gestures
    "👍",
    "👎",
    "👏",
    "🙌",
    // objects
    "💡",
    "⚙️",
    "🚀",
    "🌍",
    // celebration
    "😍",
    "🎉",
    "🎆",
    "🎊",
    // food
    "☕",
    "🍕",
    "🍔",
    "🍰",
    // activities
    "🎵",
    "📷",
    "🎨",
    "📚",
  ];

  const handleEmojiSelect = (emoji) => {
    setSelectedEmoji(emoji);
    setIsModalOpen(false);
    saveEmoji(emoji);
  };

  const handleModalClose = (e) => {
    if (e.target === e.currentTarget) {
      setIsModalOpen(false);
    }
  };

  return (
    <>
      {/* Emoji Display Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="group relative inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br from-blue-50 to-indigo-100 hover:from-blue-100 hover:to-indigo-200 border-2 border-blue-200 hover:border-blue-300 rounded-xl transition-all duration-300 ease-out transform hover:scale-105 hover:shadow-lg active:scale-95"
      >
        <span className="text-2xl transition-transform duration-200 group-hover:scale-110">
          {selectedEmoji}
        </span>

        {/* Hover overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-5 rounded-2xl transition-all duration-200" />

        {/* Edit indicator */}
        <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <svg
            className="w-3 h-3 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
          </svg>
        </div>
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50"
          onClick={handleModalClose}
        >
          <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full max-h-[80vh] overflow-hidden">
            {/* Header */}
            <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-semibold text-gray-800">
                  Choisir un emoji
                </h3>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors duration-200"
                >
                  <svg
                    className="w-4 h-4 text-gray-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <p className="text-sm text-gray-600 mt-1">
                Sélectionnez un emoji pour représenter ce partenaire.
              </p>
            </div>

            {/* Current Selection */}
            <div className="px-6 py-4 bg-gray-50 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <span className="text-2xl">{selectedEmoji}</span>
                <span className="text-sm font-medium text-gray-700">
                  Sélection actuelle
                </span>
              </div>
            </div>

            {/* Emoji Grid */}
            <div className="p-6 max-h-96 overflow-y-auto">
              <div className="grid grid-cols-8 gap-2">
                {available_emojis.map((emoji, index) => (
                  <button
                    key={index}
                    onClick={() => handleEmojiSelect(emoji)}
                    className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl transition-all duration-200 hover:scale-110 hover:bg-blue-50 ${
                      selectedEmoji === emoji
                        ? "bg-blue-100 ring-2 ring-blue-400 scale-105"
                        : "hover:shadow-md active:scale-95"
                    }`}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const findEmojiofPartner = async (partner, masterData) => {
  // find it's workspace
  // then return it's emoji
  if (partner && partner.workspaces_id && partner.workspaces_id.length > 0) {
    const workspaces = await getArrayDocDataByID(
      "workspace",
      partner.workspaces_id
    );
    let matching_workspace = workspaces.find(
      (ws) => ws.master_id === masterData.id
    );
    if (matching_workspace) {
      return matching_workspace.emoji || "";
    } else {
      return "";
    }
  } else {
    return "";
  }
};
